import React, { ReactNode } from 'react'

import { HeadingBlock, HeadingNode } from './types'

const structureData = (
  rtfReactNodes: Array<ReactNode | HeadingNode>,
  index: number,
  outlineSection: HeadingBlock
): [HeadingBlock, number] => {
  const { content, level } = outlineSection
  let i = index
  for (; i < rtfReactNodes.length; i++) {
    const rtfReactNode = rtfReactNodes[i]
    if (
      React.isValidElement(rtfReactNode) &&
      'blockType' in rtfReactNode &&
      rtfReactNode.blockType === 'HeadingBlock'
    ) {
      // This block is a heading block
      const {
        headingRank,
        slugified,
        props: { children },
        key,
      } = rtfReactNode as HeadingNode
      if (headingRank > level) {
        // We found a sub-heading
        const [subSection, endIndex] = structureData(rtfReactNodes, i + 1, {
          isHeadingBlock: true,
          level: headingRank,
          key,
          children,
          slugified,
          content: [],
        })
        content.push(subSection)
        i = endIndex
      } else {
        // We reached the end of this section's content
        i-- // The current i isn't part of the section anymore
        break
      }
    } else {
      // This block is not a heading, but any other content block
      content.push({ block: rtfReactNode, i, isHeadingBlock: false })
    }
  }
  return [outlineSection, i]
}

export default structureData
